import { render, staticRenderFns } from "./ClientProjectReport.vue?vue&type=template&id=52d222d3&scoped=true&"
import script from "./ClientProjectReport.vue?vue&type=script&lang=js&"
export * from "./ClientProjectReport.vue?vue&type=script&lang=js&"
import style0 from "./ClientProjectReport.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClientProjectReport.vue?vue&type=style&index=1&id=52d222d3&lang=scss&scoped=true&"
import style2 from "./ClientProjectReport.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d222d3",
  null
  
)

export default component.exports